module.exports = __webpack_public_path__ + "static/media/trashboy_la987.2d93839d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/trashboy_la987.jpg
// module id = 468
// module chunks = 0